"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Treatment_1 = __importDefault(require("../models/Treatment"));
const trans_1 = require("@common/tsutils/trans");
class Location {
    constructor(data) {
        this.currentTime = data.currentTime;
        this.id = data.id;
        this.name = data.name;
        this.samplesTotalThisTime = data.samplesTotalThisTime;
        this.time_details = data.time_details;
        this.treatment_details = data.treatment_details.map((t) => new Treatment_1.default(t));
    }
    get collectId() {
        return this.id;
    }
    get collectName() {
        return this.name;
    }
    get collectSamplesTotalThisTime() {
        return this.samplesTotalThisTime;
    }
    get collectTimeDetails() {
        return this.time_details;
    }
    get isCompleted() {
        if (this.time_details.every((t) => t.samplesAssigned === t.samplesTotalThisTime))
            return true;
        return false;
    }
    get accent() {
        if (this.isCompleted)
            return 'success';
        if (this.time_details[this.currentTime].samplesAssigned === this.time_details[this.currentTime].samplesTotalThisTime)
            return 'info';
        return 'primary';
    }
    get timeProgress() {
        if (this.isCompleted)
            return 100;
        return this.time_details[this.currentTime].samplesAssigned / this.time_details[this.currentTime].samplesTotalThisTime * 100;
    }
    get ctaText() {
        if (this.isCompleted)
            return (0, trans_1.trans)('trialsInTracking.card_location.end');
        const nextTime = this.currentTime + 1;
        if (this.accent === 'info') {
            if (nextTime < this.time_details.length) {
                return (0, trans_1.trans)('trialsInTracking.card_location.assign') + ' T' + nextTime;
            }
            else {
                return (0, trans_1.trans)('trialsInTracking.card_location.end');
            }
        }
        else {
            return (0, trans_1.trans)('trialsInTracking.card_location.assign') + ' T' + this.currentTime;
        }
    }
}
exports.default = Location;
